import React, { useState } from 'react';
import PaymentDetailsAdminList from './components/PaymentDetailsAdminList';
import PaymentDetailsAddPage from './components/PaymentDetailsAddPage';
import { Box, Tabs, Tab } from '@mui/material';

const AdminPaymentDetailsPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="Payment Details admin tabs">
        <Tab label="List Payment Details" />
        <Tab label="Add Payment Record" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <PaymentDetailsAdminList />}
        {tab === 1 && <PaymentDetailsAddPage />}
      </Box>
    </Box>
  );
};

export default AdminPaymentDetailsPage;
